export const toggleConstant = (prefix: string) => `${prefix}_NOTIFICATION_TOGGLE`
export const closeConstant = (prefix: string) => `${prefix}_NOTIFICATION_CLOSE`
export const openConstant = (prefix: string) => `${prefix}_NOTIFICATION_OPEN`

export const createConstants = (prefix: string) => ({
  close: closeConstant(prefix),
  open: openConstant(prefix),
  toggle: toggleConstant(prefix),
})
